"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIDEBAR_BACKDROP_BACKGROUND = exports.SIDEBAR_TRANSITION = exports.SIDEBAR_WIDTH = exports.SIDEBAR_PUSH_THRESHOLD_MEDIA_QUERY = void 0;
const tslib_1 = require("tslib");
const utilities_1 = require("../Themes/utilities");
const polished_1 = require("polished");
const HeaderBar_1 = tslib_1.__importDefault(require("../HeaderBar"));
const LayoutContext_1 = tslib_1.__importDefault(require("../TheLayout/LayoutContext"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_dom_1 = tslib_1.__importDefault(require("react-dom"));
const styled_components_1 = tslib_1.__importStar(require("../Themes/styled-components"));
const lodash_uniqueid_1 = tslib_1.__importDefault(require("lodash.uniqueid"));
const BASE_ZINDEX = 20;
let zIndexCounter = 0;
exports.SIDEBAR_PUSH_THRESHOLD_MEDIA_QUERY = 'xl';
exports.SIDEBAR_WIDTH = 320;
exports.SIDEBAR_TRANSITION = '0.2s ease-in-out';
exports.SIDEBAR_BACKDROP_BACKGROUND = 'rgba(0, 0, 0, 0.25)';
const FixedWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: ${({ $zIndex }) => BASE_ZINDEX + $zIndex};
  ${(0, utilities_1.mb)('m')} {
    border-left: 1px solid ${({ theme }) => theme.separatorColor};
  }
  ${({ $visible }) => {
    if ($visible) {
        return (0, styled_components_1.css) `
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      `;
    }
    return (0, styled_components_1.css) `
      top: 100%;
      right: 0;
      bottom: -100%;
      left: 0;
    `;
}} height: 100%;
  background: white;
  z-index: 3;
  transition: all ${exports.SIDEBAR_TRANSITION};
  ${(0, utilities_1.mb)('m')} {
    ${({ $visible }) => $visible
    ? (0, styled_components_1.css) `
            top: 0;
            left: calc(100% - ${(0, polished_1.rem)(exports.SIDEBAR_WIDTH)});
          `
    : (0, styled_components_1.css) `
            top: 0;
            left: 100%;
          `}
  }
`;
const StaticWrapper = styled_components_1.default.div `
  position: absolute;
  display: flex;
  flex-direction: column;
  height: 100%;
  z-index: ${({ $zIndex }) => BASE_ZINDEX + $zIndex};
  transition: all ${exports.SIDEBAR_TRANSITION};
  background-color: ${({ theme }) => theme.backgroundColor};

  ${({ $visible, $position }) => $position === 'right'
    ? (0, styled_components_1.css) `
          top: 0;
          bottom: 0;
          right: ${$visible ? 0 : '-100%'};
          width: 100%;
          ${(0, utilities_1.mb)('s')} {
            width: ${(0, polished_1.rem)(exports.SIDEBAR_WIDTH)};
            box-shadow: -1px 0px 4px rgba(0, 0, 0, 0.08);
          }
        `
    : (0, styled_components_1.css) `
          top: 0;
          bottom: 0;
          left: ${$visible ? 0 : '-100%'};
          width: 100%;
          ${(0, utilities_1.mb)('s')} {
            width: ${(0, polished_1.rem)(exports.SIDEBAR_WIDTH)};
            box-shadow: 1px 0px 4px rgba(0, 0, 0, 0.08);
          }
        `}
`;
const ScrollContent = styled_components_1.default.div `
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 0 0;
`;
const SidebarBackdrop = styled_components_1.default.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${({ zIndex }) => BASE_ZINDEX + zIndex};
  background-color: ${exports.SIDEBAR_BACKDROP_BACKGROUND};
  transition: all ${exports.SIDEBAR_TRANSITION};
  ${({ isOpen, modal }) => {
    if (!modal) {
        if (isOpen) {
            return (0, styled_components_1.css) `
          opacity: 1;
          ${(0, utilities_1.mb)(exports.SIDEBAR_PUSH_THRESHOLD_MEDIA_QUERY)} {
            pointer-events: none;
            opacity: 0;
          }
        `;
        }
        else {
            return (0, styled_components_1.css) `
          pointer-events: none;
          opacity: 0;
        `;
        }
    }
    else {
        if (isOpen) {
            return (0, styled_components_1.css) `
          opacity: 1;
        `;
        }
        else {
            return (0, styled_components_1.css) `
          pointer-events: none;
          opacity: 0;
        `;
        }
    }
}}
`;
class Sidebar extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.init = () => {
            const ctx = this.context;
            this.setState({ zIndex: ++zIndexCounter, initializing: false });
            ctx.attachSidebar({
                id: this.id,
                opened: this.props.visible,
                modal: this.props.modal,
                position: this.props.position,
            });
        };
        this.destroy = () => {
            const ctx = this.context;
            ctx.detachSidebar({
                id: this.id,
            });
        };
        this.update = () => {
            const ctx = this.context;
            ctx.updateSidebar({
                id: this.id,
                opened: false,
                modal: this.props.modal,
                position: this.props.position,
            });
        };
        this.id = (0, lodash_uniqueid_1.default)('sidebar');
        this.state = {
            zIndex: 0,
            initializing: true,
        };
    }
    componentDidMount() {
        if (this.props.visible) {
            this.init();
        }
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.visible && this.props.visible) {
            this.init();
        }
        else if (prevProps.visible && !this.props.visible) {
            this.update();
        }
        if (prevProps.modal !== this.props.modal) {
            this.update();
        }
    }
    componentWillUnmount() {
        this.destroy();
    }
    render() {
        const { header, onClose, visible, children, modal, position } = this.props;
        const { zIndex, initializing } = this.state;
        if (initializing) {
            return null;
        }
        const content = (react_1.default.createElement(react_1.default.Fragment, null,
            header && (react_1.default.createElement(HeaderBar_1.default, null,
                react_1.default.createElement(HeaderBar_1.default.Header, null, header),
                react_1.default.createElement(HeaderBar_1.default.Spacer, null),
                onClose && (react_1.default.createElement(HeaderBar_1.default.Action, { icon: "close", onClick: onClose })))),
            react_1.default.createElement(ScrollContent, null, children)));
        return (react_1.default.createElement(LayoutContext_1.default.Consumer, null, context => {
            if (context) {
                const container = position === 'left'
                    ? context.leftSidebarPlaceholderRef.current
                    : context.rightSidebarPlaceholderRef.current;
                if (container) {
                    return react_dom_1.default.createPortal(react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(SidebarBackdrop, { zIndex: zIndex, isOpen: visible, onClick: onClose, modal: modal }),
                        react_1.default.createElement(StaticWrapper, { "$zIndex": zIndex, "$visible": visible, "$position": position }, content)), container);
                }
            }
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(SidebarBackdrop, { zIndex: zIndex, isOpen: visible, modal: modal }),
                react_1.default.createElement(FixedWrapper, { "$zIndex": zIndex, "$visible": visible }, content)));
        }));
    }
}
Sidebar.defaultProps = {
    visible: false,
    modal: false,
    position: 'right',
};
Sidebar.contextType = LayoutContext_1.default;
exports.default = Sidebar;
